import store from 'client/store';
import { ThunkDispatch } from 'redux-thunk';
import { sleep } from 'common/utils/helpers';
import {
	sendFinishStoryEvent,
	sendStartStoryEvent,
	sendRegisterEvent,
	sendCardViewEvent,
	sendStoryViewEvent,
} from 'client/actions/api-events';

class _ApiEvents {
	dispatch: ThunkDispatch<any, any, any> = store.dispatch;

	viewedCards: string[] = [];

	isStoryViewSent: boolean = false;

	isFinishStorySent: boolean = false;

	isStartStorySent: boolean = false;

	isRegisterSent: boolean = false;

	sendStartStoryEvent = (payload: Parameters<typeof sendStartStoryEvent>[0]) => {
		if (this.isStartStorySent) {
			return;
		}

		this.dispatch(sendStartStoryEvent(payload));
		this.isStartStorySent = true;
	};

	sendFinishStoryEvent = (payload: Parameters<typeof sendFinishStoryEvent>[0]) => {
		if (this.isFinishStorySent) {
			return;
		}

		this.dispatch(sendFinishStoryEvent(payload));
		this.isFinishStorySent = true;
	};

	sendCardViewEvent = (payload: Parameters<typeof sendCardViewEvent>[0]) => {
		const isNewId = !this.viewedCards.includes(payload.cardId);

		if (!isNewId) {
			return;
		}

		this.dispatch(sendCardViewEvent(payload));
		this.viewedCards.push(payload.cardId);
	};

	sendStoryViewEvent = async (payload: Parameters<typeof sendStoryViewEvent>[0], defer?: boolean) => {
		if (this.isStoryViewSent) {
			return;
		}

		if (defer) await sleep(1000);

		this.dispatch(sendStoryViewEvent(payload));
		this.isStoryViewSent = true;
	};

	sendRegisterEvent = async (payload: Parameters<typeof sendRegisterEvent>[0], defer?: boolean) => {
		if (this.isRegisterSent) {
			return;
		}

		if (defer) await sleep(1000);

		this.dispatch(sendRegisterEvent(payload));
		this.isRegisterSent = true;
	};
}

export const ApiEvents = new _ApiEvents();
